import { render, staticRenderFns } from "./ContentLayer.vue?vue&type=template&id=5c61cef1&"
import script from "./ContentLayer.vue?vue&type=script&lang=js&"
export * from "./ContentLayer.vue?vue&type=script&lang=js&"
import style0 from "./ContentLayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports